import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { Link } from "react-router-dom";
import { get, isEmpty, filter, forEach, size } from "lodash";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";

import Timer from "../../Common/Timer";
import Loader from "../../Common/Loader";
import Picture from "../../Common/Picture";
import TagColor from "../../Common/TagColor";
import LiveCardAction from "./LiveCardAction";
import CountDown from "../../Common/CountDown";
import WearingMask from "../../Common/WearingMask";
import CustomButton from "../../Common/CustomButton";

import { clearZoneEvents } from "../../../actions/siteEntranceExit/liveEvents";
import { getLatestLog } from "../../../actions/siteEntranceExit/tabs";

import { formatDate } from "../../../utils/date";
import { getTextColor } from "../../../utils/color";
import {
  getTemperatureByOperation,
  getThreshold,
} from "../../../utils/temperature";
import { getAttributeValue, isUnknownProfile } from "../../../utils/profile";
import { findEventTypeInTree } from "../../../utils/event";

import { unidentified } from "../../../constants/common";
import { walkInOut } from "../../../constants/reducers";
import {
  frResults,
  comments,
  verifications,
  measuredTemperature,
} from "../../../constants/liveEvents";

import { ENV, TFI } from "../../../client-config";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = (theme) => ({
  mainContent: {
    backgroundImage: ENV === TFI ? `url(${images.tfiSign})` : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "1200px",
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px 0px 30px 0px",
    overflow: "auto",
    minHeight: "250px",
    padding: "16px 8px",
    maxHeight: "455px",
    height: "455px",
  },
  cardContainer: {
    height: "420px",
    padding: "0px 8px",
    minWidth: "280px",
    maxWidth: "280px",
  },
  card: {
    borderRadius: "4px",
    height: "100%",
    boxShadow: "0px 2px 20px 6px " + colors.black7,
    position: "relative",
    backgroundColor: colors.white,
  },
  cardTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "31px",
    minHeight: "31px",
    fontWeight: "500",
    fontSize: "1.125em",
    borderRadius: "4px 4px 0px 0px",
  },
  detailField: {
    marginTop: "5px",
    height: "20px",
  },
  detailFieldTitle: {
    color: colors.black87,
    fontWeight: "500",
    marginRight: "5px",
  },
  tooltip: {
    marginTop: "5px",
    fontSize: "1em",
    padding: "8px 16px",
    fontWeight: "400",
  },
  link: {
    color: colors.primary,
  },
  actionButtonItem: {
    width: "50px",
    textAlign: "center",
  },
});

const LiveEventsWalkInOut = (props) => {
  const { dispatch, classes, entries, language } = props;
  const events = entries.events;

  // const getZoneName = (item) => {
  //   let zone;
  //   let events = get(item, ["detectionEventGroup", "events"]);
  //   if (events) {
  //     events = events
  //       .map((event) => get(event, ["zone", "name"]))
  //       .filter((z) => z !== undefined);
  //     if (events.length > 0) {
  //       zone = events[0];
  //     }
  //   }
  //   return zone;
  // };

  // const defineAccess = async (item, granted) => {
  //   let event;
  //   let events = get(item, ["dac", "events"]);
  //   if (events) {
  //     event = events.filter((e) => [58, 59].includes(get(e, ["type", "id"])));
  //     if (event) {
  //       event = event[0];
  //     }
  //   }
  //   if (event) {
  //     try {
  //       await fetchPut(`events/${event.id}/attributes/105`, {
  //         value: granted ? 43 : 44,
  //       });
  //       dispatch(
  //         clearZoneEvents(
  //           walkInOut,
  //           get(item, ["zone_id"]),
  //           get(item, ["session_id"])
  //         )
  //       );
  //       dispatch(
  //         getLatestLog(
  //           walkInOut,
  //           get(props.siteEntranceExit, [walkInOut, "activeTab"])
  //         )
  //       );
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }
  // };

  const closeCard = (item) => {
    dispatch(
      clearZoneEvents(
        walkInOut,
        get(item, ["zone_id"]),
        get(item, ["session_id"])
      )
    );
    dispatch(
      getLatestLog(
        walkInOut,
        get(props.siteEntranceExit, [walkInOut, "activeTab"])
      )
    );
  };

  const getHeaderColor = (item, barcodeMismatch) => {
    let lukeAction = get(
      filter(
        get(item, ["verification", "events"]),
        (e) => get(e, ["type", "id"]) === 88 && get(e, ["active"])
      ),
      [0]
    );
    if (!lukeAction) {
      forEach(get(item, ["verification", "events"]), (ev) => {
        forEach(get(ev, ["events"]), (e) => {
          if (get(e, ["type", "id"]) === 88 && get(e, ["active"])) {
            lukeAction = e;
          }
        });
      });
    }
    if (lukeAction) {
      let attr159 = get(
        filter(
          get(lukeAction, ["attributes"]),
          (attr) => get(attr, ["id"]) === 159
        ),
        [0, "value"]
      );
      console.log(attr159);
      if (size(attr159)) {
        attr159 = JSON.parse(attr159);
        if (get(attr159, ["id"]) === 0) {
          return colors.cardGreen;
        } else if (get(attr159, ["id"]) === 1) {
          return colors.unknownYellow;
        } else if (get(attr159, ["id"]) === 2) {
          return colors.threatRed;
        } else if (get(attr159, ["id"]) === 3) {
          return colors.warningOrange;
        }
      }
      return colors.cardTitleBg;
    } else {
      // Threat Profile
      if (get(item, ["detectionEventGroup", "profile", "tag", "threat_flag"])) {
        return colors.threatRed;
      }
      // Temperature threat
      const maxTemperature = getTemperatureByOperation(
        get(item, ["measuredTemperature"]),
        "max"
      );
      const threshold = getThreshold(get(item, ["measuredTemperature"]));
      if (maxTemperature > threshold) {
        return colors.threatRed;
      }
      // Barcode mismatch
      if (barcodeMismatch) {
        return colors.threatRed;
      }
      //Covid Status
      let survey = get(item, ["verification", "lastSurvey"]);
      if (!survey) {
        survey = get(item, ["verification", "referenceSurvey"]);
      }
      if (survey) {
        let attr151 = survey.attributes.filter((attr) => attr.id === 151);
        if (attr151 && attr151.length > 0) {
          attr151 = JSON.parse(get(attr151, [0, "value"]));
          if (get(attr151, ["survey_instructions", "id"]) === 0) {
            return colors.cardGreen;
          } else if (get(attr151, ["survey_instructions", "id"]) === 1) {
            return colors.unknownYellow;
          } else if (get(attr151, ["survey_instructions", "id"]) === 2) {
            return colors.threatRed;
          } else if (get(attr151, ["survey_instructions", "id"]) === 3) {
            return colors.warningOrange;
          }
        }
      }
      // Unknown person
      if (get(item, ["state"]) === unidentified) {
        return colors.unknownYellow;
      }
    }
    return colors.cardTitleBg;
  };

  const renderValue = (value, noShorten = false, type) => {
    let displayValue = value;
    let shorten = false;
    let maxLength = type === "tag" ? 10 : 12;
    if (value && value.length > maxLength && !noShorten) {
      displayValue = value.substring(0, maxLength - 2) + "...";
      shorten = true;
    }

    if (shorten) {
      return (
        <Tooltip
          title={value}
          classes={{ tooltip: this.props.classes.tooltip }}
        >
          <span className="text-54" style={{ whiteSpace: "nowrap" }}>
            {displayValue}
          </span>
        </Tooltip>
      );
    }
    return (
      <span className="text-54" style={{ whiteSpace: "nowrap" }}>
        {displayValue}
      </span>
    );
  };

  const renderEventCard = (item) => {
    if (!get(item, ["detectionEventGroup"])) {
      return renderEmptyCard(true);
    }

    const barcodeResultEvent = get(
      findEventTypeInTree(get(item, ["detectionEventGroup"]), [7, 8]),
      [0]
    );
    let barcodeMatch = get(barcodeResultEvent, ["profile", "id"]);
    let barcodeProfile = get(barcodeResultEvent, ["profile"]);

    if (isUnknownProfile(barcodeMatch)) {
      barcodeMatch = null;
    }

    const faceDetectionEvents = findEventTypeInTree(
      get(item, ["detectionEventGroup"]),
      [2]
    );

    let faceMatch;
    forEach(faceDetectionEvents, (e) => {
      if (
        size(
          filter(get(e, ["events"]), (se) => get(se, ["type", "id"]) === 5)
        ) > 0
      ) {
        faceMatch = get(
          filter(get(e, ["events"]), (se) => get(se, ["type", "id"]) === 5),
          [0, "profile", "id"]
        );
      } else if (
        faceMatch === undefined &&
        size(
          filter(get(e, ["events"]), (se) => get(se, ["type", "id"]) === 6)
        ) > 0
      ) {
        faceMatch = get(
          filter(get(e, ["events"]), (se) => get(se, ["type", "id"]) === 6),
          [0, "profile", "id"]
        );
      }
    });

    const capturedPhoto =
      get(item, ["detection", "capturedImages", 0]) ||
      get(item, ["detection", "contextPhotos", 0]);
    const profilePhoto = get(
      filter(
        get(item, ["detectionEventGroup", "profile", "images"]),
        (img) => img.active && img.enrollment_status
      ),
      [0, "url"]
    );

    const headerColor = getHeaderColor(
      item,
      faceMatch &&
        !isUnknownProfile(faceMatch) &&
        barcodeMatch &&
        !isUnknownProfile(barcodeMatch) &&
        faceMatch !== barcodeMatch
        ? true
        : false
    );

    return (
      <Grid item className={classes.cardContainer}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          className={classes.card}
        >
          <Grid
            item
            className={classes.cardTitle}
            style={{
              backgroundColor: headerColor,
              color: getTextColor(headerColor),
            }}
          >
            {I18n.get("site_human")}
          </Grid>
          <Grid item xs>
            <Grid
              container
              direction="column"
              style={{ height: "100%", padding: "0px 10px" }}
            >
              <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {I18n.get("site_status")}:
                      </Grid>
                      <Grid item>
                        {renderValue(
                          get(item, [
                            "detectionEventGroup",
                            "status",
                            `name_${language}`,
                          ]),
                          true,
                          "status"
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {I18n.get("site_zone")}:
                      </Grid>
                      <Grid item>
                        {renderValue(getZoneName(item), true, "zone")}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {I18n.get("site_startTime")}
                      </Grid>
                      <Grid item>
                        {get(item, ["detectionEventGroup", "start"]) &&
                          renderValue(
                            formatDate(
                              get(item, ["detectionEventGroup", "start"]),
                              "hh:mm:ss A"
                            ),
                            true,
                            "startTime"
                          )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {item.timeout
                          ? I18n.get("site_clearingIn")
                          : I18n.get("site_elapsed")}
                      </Grid>
                      <Grid item>
                        {item.timeout ? (
                          <CountDown
                            duration={
                              get(item, ["cleaningTimestamp"]) - Date.now()
                            }
                          />
                        ) : (
                          <Timer
                            from={
                              new Date(
                                get(item, ["detectionEventGroup", "start"])
                              ).getTime() || 0
                            }
                            freeze={false}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={classes.detailField}>
                {get(item, ["detectionEventGroup", "profile", "id"]) &&
                  !isUnknownProfile(
                    get(item, ["detectionEventGroup", "profile", "id"])
                  ) && (
                    <Grid container>
                      <Grid item>
                        <Grid container wrap="nowrap">
                          <Grid item className={classes.detailFieldTitle}>
                            <img
                              src={images.humanIconBlack}
                              width="16px"
                              alt="human_icon"
                            />
                          </Grid>
                          <Grid
                            item
                            xs
                            className="flexCenter"
                            style={{ minWidth: "100px" }}
                          >
                            <Link
                              to={`/profiles/${get(item, [
                                "detectionEventGroup",
                                "profile",
                                "id",
                              ])}`}
                              className={classes.link}
                            >
                              <span>
                                {`${getAttributeValue(
                                  get(item, ["detectionEventGroup", "profile"]),
                                  31
                                )} ${getAttributeValue(
                                  get(item, ["detectionEventGroup", "profile"]),
                                  32
                                )}`}
                              </span>
                            </Link>
                            {get(item, [
                              "detectionEventGroup",
                              "luke_index",
                            ]) && (
                              <span
                                className="text-87"
                                style={{ marginLeft: "5px" }}
                              >
                                (
                                {Math.round(
                                  parseFloat(
                                    get(item, [
                                      "detectionEventGroup",
                                      "luke_index",
                                    ])
                                  ) * 100
                                )}
                                %)
                              </span>
                            )}
                            {get(item, [
                              "detectionEventGroup",
                              "profile",
                              "tag",
                              "threat_flag",
                            ]) && (
                              <span
                                style={{ marginLeft: "5px", height: "20px" }}
                              >
                                <img
                                  src={images.threatFlag}
                                  height="16px"
                                  alt="threat_flag"
                                />
                              </span>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
              </Grid>
              <Grid item className={classes.detailField}>
                {get(item, [
                  "detectionEventGroup",
                  "profile",
                  "tag",
                  `name_${language}`,
                ]) && (
                  <Grid container>
                    <Grid item>
                      <Grid container wrap="nowrap">
                        <Grid item>
                          <TagColor
                            color={`#${get(item, [
                              "detectionEventGroup",
                              "profile",
                              "tag",
                              "color_rgb",
                            ])}`}
                          />
                        </Grid>
                        <Grid item>
                          {renderValue(
                            get(item, [
                              "detectionEventGroup",
                              "profile",
                              "tag",
                              `name_${language}`,
                            ]) || I18n.get("site_unknown"),
                            true,
                            "tag"
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item style={{ marginTop: "4px" }}>
                <Grid container wrap="nowrap">
                  <Grid item xs={6} style={{ paddingRight: "10px" }}>
                    <Grid container direction="column">
                      <Grid
                        item
                        className="text-center"
                        style={{ height: "17px" }}
                      >
                        <img
                          src={images.cameraPhotoIcon}
                          height="12px"
                          alt="camera_icon"
                        />
                      </Grid>
                      <Grid
                        item
                        className="flexCenter"
                        style={{
                          position: "relative",
                          justifyContent: "center",
                          border: `1px solid ${colors.veryLighPink}`,
                        }}
                      >
                        <Picture
                          url={capturedPhoto}
                          alt="profile_picture"
                          justify="left"
                          maxHeight={100}
                          noPhotoDecoration={true}
                          noLoadingBorder={true}
                          style={{
                            maxWidth: "100px",
                            maxHeight: "100px",
                            marginLeft: 0,
                          }}
                        />
                        {faceMatch && !isUnknownProfile(faceMatch) && (
                          <img
                            src={images.greenCheckmarkWhite}
                            width="19px"
                            style={{
                              position: "absolute",
                              bottom: "-9px",
                              right: "-9px",
                            }}
                            alt="face_match"
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6} style={{ paddingLeft: "10px" }}>
                    <Grid container direction="column">
                      <Grid
                        item
                        className="text-center"
                        style={{ height: "17px" }}
                      >
                        <img
                          src={images.humanIconBlack}
                          height="12px"
                          alt="camera_icon"
                        />
                      </Grid>
                      <Grid
                        item
                        className="flexCenter"
                        style={{
                          justifyContent: "center",
                          border: `1px solid ${colors.veryLighPink}`,
                          height: "102px",
                        }}
                      >
                        {isUnknownProfile(
                          get(item, ["detectionEventGroup", "profile", "id"])
                        ) ? (
                          <img src={images.unknownHuman} alt="unknown" />
                        ) : (
                          <Picture
                            url={profilePhoto}
                            alt="profile_picture"
                            justify="left"
                            maxHeight={100}
                            noPhotoDecoration={true}
                            noLoadingBorder={true}
                            style={{
                              maxWidth: "100px",
                              maxHeight: "100px",
                              marginLeft: 0,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ marginTop: "15px" }}>
                <Grid container wrap="nowrap">
                  <Grid
                    item
                    className="flexCenter"
                    style={{ width: "45px", justifyContent: "center" }}
                  >
                    <WearingMask
                      humanIdentificationEventGroup={get(item, [
                        "detectionEventGroup",
                      ])}
                    />
                  </Grid>
                  <Grid item className={classes.actionButtonItem}>
                    <LiveCardAction
                      section={walkInOut}
                      zoneId={get(item, ["zone_id"])}
                      sessionId={get(item, ["session_id"])}
                      action={frResults}
                      actionProps={{
                        event: item,
                        faceMatch: faceMatch && !isUnknownProfile(faceMatch),
                      }}
                    />
                  </Grid>
                  <Grid item className={classes.actionButtonItem}>
                    <LiveCardAction
                      section={walkInOut}
                      zoneId={get(item, ["zone_id"])}
                      sessionId={get(item, ["session_id"])}
                      action={verifications}
                      actionProps={{
                        item,
                        verificationEventGroup: get(item, ["verification"]),
                        language,
                        profile: get(item, ["detectionEventGroup", "profile"]),
                      }}
                    />
                  </Grid>
                  <Grid item className={classes.actionButtonItem}>
                    <LiveCardAction
                      section={walkInOut}
                      zoneId={get(item, ["zone_id"])}
                      sessionId={get(item, ["session_id"])}
                      action={measuredTemperature}
                      actionProps={{
                        hasLeft: get(item, ["timeout"]) ? true : false,
                        data: get(item, ["measuredTemperature"]),
                        startTime:
                          new Date(
                            get(item, ["detectionEventGroup", "start"])
                          ).getTime() || 0,
                      }}
                    />
                  </Grid>
                  <Grid item className={classes.actionButtonItem}>
                    <LiveCardAction
                      section={walkInOut}
                      zoneId={get(item, ["zone_id"])}
                      sessionId={get(item, ["session_id"])}
                      action={comments}
                      actionProps={{
                        dacId: item.dacId,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ marginTop: "10px", height: "29px" }}>
                {barcodeMatch && !isUnknownProfile(barcodeMatch) && (
                  <Grid container alignItems="center">
                    <Grid
                      item
                      className="flexCenter"
                      style={{ marginRight: "10px" }}
                    >
                      <img
                        src={
                          faceMatch &&
                          !isUnknownProfile(faceMatch) &&
                          faceMatch !== barcodeMatch
                            ? images.barcodeMismatchIcon
                            : images.barcodeMatchedGreen
                        }
                        alt="barcode_status"
                      />
                    </Grid>
                    <Grid item>
                      <Grid container direction="column">
                        <Grid item>{I18n.get("site_employeesCardOf")}</Grid>
                        <Grid item>
                          <Link
                            to={`/profiles/${get(barcodeProfile, ["id"])}`}
                            style={{ color: colors.primary }}
                          >
                            {` ${getAttributeValue(
                              barcodeProfile,
                              31
                            )} ${getAttributeValue(barcodeProfile, 32)}`}
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              {item.timeout && (
                <Grid item style={{ marginTop: "12px" }}>
                  <CustomButton
                    onClick={() => closeCard(item)}
                    variant="outlined"
                    color="primary"
                    fullWidth
                  >
                    {I18n.get("site_close")}
                  </CustomButton>
                </Grid>
              )}
              {/* <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {I18n.get("site_rfid")}:
                      </Grid>
                      <Grid item>
                        {renderValue(
                          getAttributeValue(
                            get(item, ["detectionEventGroup", "profile"]),
                            37
                          ),
                          true,
                          "rfid"
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid item className={classes.detailField}>
                <Grid container>
                  <Grid item>
                    <Grid container wrap="nowrap">
                      <Grid item className={classes.detailFieldTitle}>
                        {I18n.get("site_barcode")}:
                      </Grid>
                      <Grid item>
                        {renderValue(
                          getAttributeValue(
                            get(item, ["detectionEventGroup", "profile"]),
                            38
                          ),
                          true,
                          "barcode"
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid item style={{ margin: "12px 0px" }}>
                <Grid container justify="center">
                  <Grid item style={{ margin: "0px 10px" }}>
                    <CustomButton
                      variant="contained"
                      style={{
                        backgroundColor: colors.errorRed,
                        color: colors.white,
                        minWidth: "85px",
                      }}
                      onClick={() => defineAccess(item, false)}
                    >
                      {I18n.get("site_deny")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ margin: "0px 10px" }}>
                    <CustomButton
                      variant="contained"
                      style={{
                        backgroundColor: colors.green,
                        color: colors.white,
                        minWidth: "85px",
                      }}
                      onClick={() => defineAccess(item, true)}
                    >
                      {I18n.get("site_allow")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderEmptyCard = (loading = false) => {
    return (
      <Grid item className={classes.cardContainer}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          className={classes.card}
        >
          <Grid
            item
            className={classes.cardTitle}
            style={{
              backgroundColor: colors.cardTitleBg,
              color: getTextColor(colors.cardTitleBg),
            }}
          >
            {I18n.get("site_human")}
          </Grid>
          <Grid
            item
            xs
            className="flexCenter"
            style={{ justifyContent: "center" }}
          >
            {loading ? (
              <Loader message={I18n.get("site_humanDetected")} noDecoration />
            ) : (
              <img width="110px" src={images.humanIcon} alt="human_icon" />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };
  console.log(events, "eventseventseventseventsevents");
  return (
    <Grid
      container
      alignItems="stretch"
      wrap="nowrap"
      className={classes.mainContent}
    >
      {events &&
        Object.keys(events).map((key) => (
          <React.Fragment key={key}>
            {renderEventCard(events[key])}
          </React.Fragment>
        ))}
      {(!events || isEmpty(events)) && renderEmptyCard()}
    </Grid>
  );
};

LiveEventsWalkInOut.propTypes = {
  language: PropTypes.any,
  entries: PropTypes.shape({
    events: PropTypes.object,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(LiveEventsWalkInOut)
);
